<template>
    <el-dialog
            v-if="visibles"
            :visible.sync="visibles"
            :before-close="closeDialog"
            :close-on-click-modal="false"
            :lock-scroll="false"
            :destroy-on-close="true"
            :show-close="false"
            top="2vh"
            width="70%"
            center
    >
        <dialog-header
                slot="title"
                :title="!isEdit?$t('baseData.configResponse.createAndUpdate.create'):$t('baseData.configResponse.createAndUpdate.update')"
                :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
                @close="closeDialog"
        />
        <vue-linetitle>
            <el-form
                    ref="formCenter"
                    :model="formInfo"
                    :label-position="'right'"
                    label-width="auto"
            >
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('baseData.configResponse.configName')+'：'" prop="configName">
                        <el-input v-model="formInfo.configName"  clearable :placeholder="$t('baseData.configResponse.configName')" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item  required :show-message="false" :label="$t('baseData.configResponse.responseHeadCmd')+'：'" prop="responseHeadCmd">
                        <el-input v-model.number="formInfo.responseHeadCmd"  clearable :placeholder="$t('baseData.configResponse.responseHeadCmd')" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseHeadErrCode')+'：'" prop="responseHeadErrCode">
                        <el-input v-model.number="formInfo.responseHeadErrCode"  clearable :placeholder="$t('baseData.configResponse.responseHeadErrCode')" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseHeadErrMsg')+'：'" prop="responseHeadErrMsg">
                        <el-input v-model="formInfo.responseHeadErrMsg"  clearable :placeholder="$t('baseData.configResponse.responseHeadErrMsg')" />
                    </el-form-item>
                </el-col>
            </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseVersion')+'：'" prop="responseVersion">
                            <el-input v-model="formInfo.responseVersion"  clearable :placeholder="$t('baseData.configResponse.responseVersion')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseInit')+'：'" prop="responseInit">
                            <el-input v-model.number="formInfo.responseInit"  clearable :placeholder="$t('baseData.configResponse.responseInit')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseUpgradeAddress')+'：'" prop="responseUpgradeAddress">
                            <el-input v-model="formInfo.responseUpgradeAddress"  clearable :placeholder="$t('baseData.configResponse.responseUpgradeAddress')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseAgpsAddress')+'：'" prop="responseAgpsAddress">
                            <el-input v-model="formInfo.responseAgpsAddress"  clearable :placeholder="$t('baseData.configResponse.responseAgpsAddress')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseBusinessAddress')+'：'" prop="responseBusinessAddress">
                            <el-input v-model="formInfo.responseBusinessAddress"  clearable :placeholder="$t('baseData.configResponse.responseBusinessAddress')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseDataMode')+'：'" prop="responseDataMode">
                            <el-select v-model="formInfo.responseDataMode" clearable :placeholder="$t('baseData.configResponse.responseDataMode')">
                                <el-option v-for="item in DataModes" :label="item.label" :value="item.value" :key="item.value" ></el-option>
                            </el-select>
                            <!-- <el-input v-model.number="formInfo.responseDataMode"  clearable :placeholder="$t('baseData.configResponse.responseDataMode')" /> -->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseDistance')+'：'" prop="responseDistance">
                            <el-input-number v-model="formInfo.responseDistance" clearable :min="1" :placeholder="$t('baseData.configResponse.responseDistance')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  required :show-message="false" :label="$t('baseData.configResponse.responseInterval')+'：'" prop="responseInterval">
                            <el-input-number v-model="formInfo.responseInterval" clearable :min="1" :placeholder="$t('baseData.configResponse.responseInterval')"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responsePacketCount')+'：'" prop="responsePacketCount">
                            <el-input-number v-model="formInfo.responsePacketCount"  clearable :min="0" :placeholder="$t('baseData.configResponse.responsePacketCount')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseFlameoutWait')+'：'" prop="responseFlameoutWait">
                            <el-input-number v-model="formInfo.responseFlameoutWait"  clearable :min="0" :max="65535" :placeholder="$t('baseData.configResponse.responseFlameoutWait')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseLinkHeartbeat')+'：'" prop="responseLinkHeartbeat">
                            <el-input-number v-model="formInfo.responseLinkHeartbeat"  clearable :min="0" :placeholder="$t('baseData.configResponse.responseLinkHeartbeat')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseSleepReportInterval')+'：'" prop="responseSleepReportInterval">
                            <el-input-number v-model="formInfo.responseSleepReportInterval"  clearable :min="0" :placeholder="$t('baseData.configResponse.responseSleepReportInterval')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseSleepVoltageInterval')+'：'" prop="responseSleepVoltageInterval">
                            <el-input-number v-model="formInfo.responseSleepVoltageInterval"  clearable :min="0" :placeholder="$t('baseData.configResponse.responseSleepVoltageInterval')" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseFlameoutShutdown')+'：'" prop="responseFlameoutShutdown">
                            <el-input-number v-model="formInfo.responseFlameoutShutdown"  clearable :min="0" :max="65535" :placeholder="$t('baseData.configResponse.responseFlameoutShutdown')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required :show-message="false" :label="$t('baseData.configResponse.responseFlameoutVoltage')+'：'" prop="responseFlameoutVoltage">
                            <el-input-number v-model="formInfo.responseFlameoutVoltage"  clearable :min="0" :max="255" :placeholder="$t('baseData.configResponse.responseFlameoutVoltage')" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
    </el-dialog>
</template>

<script>
    // 混入
    import { partialForm } from '@/mixins/partialForm'

    import {createResponse, updateResponse} from '@/api/obdDevice/nineFiveResponse'
    export default {
        name: "addUpdateDialog",
        mixins: [partialForm],
        props: {
            visibles: {
                type: Boolean,
                default: false
            },
            isEdit: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            /* const validateconfigName = (rule, value, cb) => {
                if (!value) {
                    return cb(new Error(this.$t('baseData.configResponse.createAndUpdate.error.noConfigName')))
                }
            }
            const validateresponseHeadCmd = (rule, value,cb) => {
                if(!Number.isInteger(value)){
                    return cb(new Error(this.$t('baseData.configResponse.createAndUpdate.error.isNumber')))
                }
            } */
            return{
               /*  rulesCenter: {
                    configName: [
                        { required: true, trigger: ['blur','change'],validator: validateconfigName }
                    ],
                    responseHeadCmd:[
                        {required:true, type:'number',trigger: ['blur','change'], validator:validateresponseHeadCmd }
                    ],
                    responseHeadErrCode:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseInit:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseInterval:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseDistance:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseDataMode:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responsePacketCount:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseFlameoutWait:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseLinkHeartbeat:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseSleepReportInterval:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseSleepVoltageInterval:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseFlameoutShutdown:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ],
                    responseFlameoutVoltage:[
                        {required:true, type:'number', trigger: ['blur','change']}
                    ]
                }, */
                formInfo: {  },
                DataModes:[     //数据采集模式
                    {label:'不采集',value:0},
                    {label:'时间与距离间隔条件同时满足',value:1},
                    {label:'时间与距离间隔条件满足其一',value:2}
                ]
            }
        },
        watch: {
            visibles(e1) {
                if (e1) {
                    this.formInfo = {...this.data }
                }
            }
        },
        methods:{
            // 关闭
            closeDialog() {
                this.$emit('update:visibles', false)
            },
            // 取消
            handleCancel() {
                this.closeDialog()
            },
            handleSubmit(){
                const formCheckLeft = this.checkForm({
                    formName: 'formCenter',
                    formList: [
                        'configName','responseHeadCmd','responseHeadErrCode','responseInit','responseInterval','responseDistance','responseDataMode',
                        'responsePacketCount','responseFlameoutWait','responseLinkHeartbeat','responseSleepReportInterval','responseSleepVoltageInterval',
                        'responseFlameoutShutdown','responseFlameoutVoltage'
                    ]
                })
                if (!formCheckLeft) {
                    return
                }
                if (!this.isEdit) {
                    const postData={...this.formInfo}
                    this._createTerminalCode(postData)
                } else {
                    const postData = {...this.formInfo}
                    this._updateTerminalCode(postData)
                }
            },
            // 新增
            _createTerminalCode(postData) {
                createResponse(postData).then(({ data }) => {
                    if (data.code === 0) {
                        this.$message.success({
                            message: this.$t('public.createSuccess'),
                            duration: 2 * 1000
                        })
                        this.$emit('add-complete')
                        this.closeDialog()
                    }
                }).catch(()=>{})
            },
            _updateTerminalCode(postData) {
                const id = this.data.id
                updateResponse(id,postData).then(({ data }) => {
                    if (data.code === 0) {
                        this.$message.success({
                            message:  this.$t('public.updateSuccess'),
                            duration: 2 * 1000
                        })
                        this.$emit('update-complete')
                        this.closeDialog()
                    }
                }).catch(()=>{})
            }
        }
    }
</script>

<style scoped>

</style>